import Basic4 from './Basic4'
export default Basic4
